<template>
  <div class="switch" @click="emits('update:modelValue', !modelValue)">
    <p v-if="modelValue">{{ activeText }}</p>
    <p v-else>{{ text }}</p>
    <div class="slider" :class="{ active: modelValue }"></div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  text: string
  activeText: string
  modelValue?: boolean
}>()

const emits = defineEmits(['update:modelValue'])
</script>

<style scoped>
.switch {
  color: var(--vc-dark);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border: 1px solid rgba(var(--vcrgb-dark), 0.2);
  border-radius: 50px;
  font-size: 16px;
  width: 180px;
}

.slider {
  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  position: relative;
  height: 30px;
  width: 60px;
  background-color: rgba(var(--vcrgb-primary), 0.2);
  border-radius: 30px;
}

.slider::after {
  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  content: '';
  width: 20px;
  height: 20px;
  position: absolute;
  background-color: var(--vc-primary);
  left: 7px;
  top: calc(50% - 10px);
  border-radius: 50%;
}

.active {
  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  background-color: rgba(var(--vcrgb-danger), 0.2);
}

.active::after {
  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  left: calc(100% - 27px);
  background-color: rgba(var(--vcrgb-danger));
}
</style>
